import { Button, Typography } from '@mui/material';
import { DtmfButton as DtmfButtonType } from '../constants';
import { dtmfButtonStyles } from '../styles';

interface DtmfButtonProps {
  button: DtmfButtonType;
  onClick: (digit: string) => void;
}

export const DtmfButton = ({ button, onClick }: DtmfButtonProps) => {
  const { digit, letters, isSpecial } = button;

  const handleClick = () => {
    onClick(digit);
  };

  if (isSpecial) {
    return (
      <Button
        color="secondary"
        onClick={handleClick}
        sx={{
          ...dtmfButtonStyles.base,
          ...dtmfButtonStyles.special,
        }}
      >
        {digit}
      </Button>
    );
  }

  return (
    <Button
      onClick={handleClick}
      sx={{
        ...dtmfButtonStyles.base,
        ...dtmfButtonStyles.numeric,
      }}
    >
      <Typography sx={{ mb: letters ? 0 : 2.2 }} variant="h6" color="secondary">
        {digit}
      </Typography>
      {letters && (
        <Typography variant="caption" color="secondary">
          {letters}
        </Typography>
      )}
    </Button>
  );
};
